export default __webpack_public_path__ + "images/1c0e83a23576340782023e2d88f5d8c3.jpg";